import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AddCompanyButton.module.css';

export default function AddCompanyButton({ to }) {
  return (
    <Link to={to} className={styles.button}>
      + Agregar Empresa
    </Link>
  );
}